<script>

    import { toast } from 'bulma-toast'
    import ShipmentsService from '../$services/shipments.service.js'

    import File from '../$components/file.svelte'
    import Form from '../$components/form.svelte'
    import Save from '../$components/button.save.svelte'

    let data = {}
    let loading = false

    async function uploadShipmentsTracingReport() {
    
        loading = true
        const resp = await ShipmentsService.uploadShipmentsTracingReport(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        toast({message: 'Información actualizada', type: 'is-success'})
    }
</script>

<Form on:submit={uploadShipmentsTracingReport} {loading} >
    
    <File bind:file={data.shipmentsFile} />
    <br>
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Save />
    </div>
</Form>